__turbopack_context__.v({
  "loading": "pageLoader-module__rIW21q__loading",
  "loading_center": "pageLoader-module__rIW21q__loading_center",
  "loading_center_absolute": "pageLoader-module__rIW21q__loading_center_absolute",
  "object": "pageLoader-module__rIW21q__object",
  "object_four": "pageLoader-module__rIW21q__object_four",
  "object_one": "pageLoader-module__rIW21q__object_one",
  "object_three": "pageLoader-module__rIW21q__object_three",
  "object_two": "pageLoader-module__rIW21q__object_two",
});
